import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

import { AuthModule } from '@auth';
import { CYModule } from '@modules/cy/cy.module';
import { EUModule } from '@modules/eu/eu.module';

import { ShellComponent } from '@app/shell/shell.component';
import { HeaderComponent } from 'ncp-lib';
//import { FooterComponent } from './components/footer/footer.component';
import { FooterComponent } from 'ncp-lib';
import { AsideComponent } from './components/aside/aside.component';
import { HomeComponent } from '@shell/components/home/home.component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@NgModule({
  declarations: [],
  imports: [
    NgbModule,
    CommonModule,
    RouterModule,
    AuthModule,

    CYModule,
    EUModule,

    ShellComponent,
    HeaderComponent,
    FooterComponent,
    AsideComponent,
    HomeComponent,
    RouterOutlet,
  ],
  providers: [CookieService],
})
export class ShellModule {}
